// alternativeApi.ts

import { 
    GetAlternativeQuery, 
    CreateAlternativeRequest, 
    UpdateAlternativeRequest, 
    AlternativeData, 
    DeleteAlternativeRequest,
    DeleteAllAlternativesQuery,
    GetAllAlternativesQuery,
    CompareAlternativesRequest,
    ExtractModelDataRequest
  } from "@/types";
  import { PostRequest, PostRequestFormData } from "./requests";
  
  // Retrieve an alternative by its ID (and required query fields)
  export const getByAlternativeID = async (data: GetAlternativeQuery): Promise<AlternativeData> => {
    try {
      return await PostRequest<AlternativeData>("/api/alternative/get", data);
    } catch (error) {
      console.error('Error in getByAlternativeID');
      throw error;
    }
  };
  
  // Create a new alternative
  export const createAlternative = async (data: CreateAlternativeRequest) => {
    try {
      return await PostRequestFormData("/api/alternative/create", data);
    } catch (error) {
      console.error('Error in createAlternative');
      throw error;
    }
  };
  
  // Retrieve all alternatives based on query parameters
  export const getAllAlternatives = async (data: GetAllAlternativesQuery): Promise<AlternativeData[]> => {
    try {
      return await PostRequest<AlternativeData[]>("/api/alternative/get_all", data);
    } catch (error) {
      console.error('Error in getAllAlternatives');
      throw error;
    }
  };
  
  // Update an existing alternative
  export const updateAlternative = async (data: UpdateAlternativeRequest): Promise<any> => {
    try {
      return await PostRequestFormData("/api/alternative/update", data);
    } catch (error) {
      console.error('Error in updateAlternative');
      throw error;
    }
  };
  
  // Delete a single alternative by its ID
  export const deleteAlternative = async (data: DeleteAlternativeRequest): Promise<any> => {
    try {
      return await PostRequest<any>("/api/alternative/delete", data);
    } catch (error) {
      console.error('Error in deleteAlternative');
      throw error;
    }
  };
  
  // Delete all alternatives matching the query parameters
  export const deleteAllAlternatives = async (data: DeleteAllAlternativesQuery): Promise<any> => {
    try {
      return await PostRequest<any>("/api/alternative/delete_all", data);
    } catch (error) {
      console.error('Error in deleteAllAlternatives');
      throw error;
    }
  };
  
  // Compare multiple alternatives (if applicable)
  export const compareAlternatives = async (data: CompareAlternativesRequest): Promise<any> => {
    try {
      return await PostRequest<any>("/api/alternative/compare", data);
    } catch (error) {
      console.error('Error in compareAlternatives');
      throw error;
    }
  };

  export const extractModelData = async (data: ExtractModelDataRequest): Promise<any> => {
    try {
      const result = await PostRequestFormData("/api/alternative/extract_model_data", data);
      return result;
    } catch (error) {
      console.error('Error in extractModelData');
      throw error;
    }
  };